import React from 'react';
export function FlagDivider({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`flex w-full h-1 ${className}`} data-id="element-13">
      <div className="h-full w-1/3 bg-[#FFCC00]" data-id="element-14"></div>
      <div className="h-full w-1/3 bg-[#00247D]" data-id="element-15"></div>
      <div className="h-full w-1/3 bg-[#CF142B]" data-id="element-16"></div>
    </div>;
}